export default {
  isOpen(state) {
    return state.open
  },
  manualDocked(state) {
    return state.manualDocked
  },
  messages(state) {
    return state.messages
  },
  isSending(state) {
    return state.isSending
  },
  dockedWidth(state) {
    return state.dockedWidth
  },
  getQuota(state) {
    return state.quota
  },
  suggestedActions(state) {
    return state.suggestedActions
  },
  suggestedActionsResource(state) {
    return state.suggestedActionsResource
  },
  requestedSuggestedAction(state) {
    return state.requestedSuggestedAction
  }
}
